import { TimeRule } from "../../../shared/time-rule"

const includeWiderSecondaryMarketPartial = {
  action: "close",
  operationId: "includeWiderSecondaryMarket",
  description:
    "Courses offered and available on secondary market are visible to the restaurant before this time",
  userRole: "Restaurant",
} as const

const prepTimePartial = {
  operationId: "prepTime",
  description: "Restaurant can confirm prep for orders within this time window",
  userRole: "Restaurant",
} as const

export const timeRules = [
  new TimeRule({
    ...includeWiderSecondaryMarketPartial,
    daysOffset: -1,
    mealTime: "Lunch",
    time: "16:00:00",
  }),
  new TimeRule({
    ...includeWiderSecondaryMarketPartial,
    daysOffset: 0,
    mealTime: "Dinner",
    time: "16:30:00",
  }),
  new TimeRule({
    ...prepTimePartial,
    action: "open",
    daysOffset: 0,
    mealTime: "Lunch",
    time: "06:00:00",
  }),
  new TimeRule({
    ...prepTimePartial,
    action: "close",
    daysOffset: 0,
    mealTime: "Lunch",
    time: "11:00:00",
  }),
  new TimeRule({
    ...prepTimePartial,
    action: "open",
    daysOffset: 0,
    mealTime: "Dinner",
    time: "16:00:00",
  }),
  new TimeRule({
    ...prepTimePartial,
    action: "close",
    daysOffset: 0,
    mealTime: "Dinner",
    time: "19:00:00",
  }),
]
